export default __webpack_public_path__ + "static/media/846.aef5b60d.jpg";